import { get, isNull, capitalize } from "lodash";
export function copyStringToClipboard(str) {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(str);
  } else {
    const el = document.createElement("textarea");
    el.value = str;
    el.setAttribute("readonly", "");
    el.style.cssText = {
      position: "absolute",
      left: "-9999px"
    };
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
  }
}
export const isEdge = /Edge/.test(navigator.userAgent);
export const isMobile = /iPhone|iPad|iPod|Android|BlackBerry|Tablet|Mobile|Opera Mini|IEMobile/i.test(navigator.userAgent);
export const isSafari = navigator.vendor && navigator.vendor.indexOf("Apple") > -1 && navigator.userAgent && navigator.userAgent.indexOf("Safari") !== -1;
export const isAbsoluteUrl = url => /(http(s?)):\/\//gi.test(url);
export const getCurrentYear = () => new Date().getFullYear();
export const formatMessage = (template, ...args) => template.replace(/\{(\d)\}/g, (s, num) => args[num]);
export const toUpperStartCase = str => str.replace(/\w+/g, capitalize);
export const getAnyway = (object, path, defaultValue) => {
  const value = get(object, path, defaultValue);
  return isNull(value) ? defaultValue : value;
};
export const copyDivToClipboard = element => {
  const range = document.createRange();
  range.selectNode(element);
  window.getSelection().removeAllRanges();
  window.getSelection().addRange(range);
  document.execCommand("copy");
  window.getSelection().removeAllRanges();
};
export const scrollToTop = () => {
  if (isMobile) {
    window.scrollTop = 0;
  } else {
    const scrollContainer = document.getElementById("scrollContainer");

    if (scrollContainer && scrollContainer.current) {
      scrollContainer.current.scrollTop = 0;
    }
  }
};